export var AnalyticsSources;
(function (AnalyticsSources) {
    AnalyticsSources["Onboarding"] = "onboarding";
    AnalyticsSources["OnboardingBuilder"] = "onboarding-builder";
    AnalyticsSources["SdkWebPfl"] = "sdk/web/pfl";
    AnalyticsSources["SdkWebDd"] = "sdk/web/dd";
    AnalyticsSources["SdkWebFa"] = "sdk/web/fa";
})(AnalyticsSources || (AnalyticsSources = {}));
